export { default as Flag } from './components/Flag';
export { Language } from './components/Language';
export { useLanguageSwitcher } from './hooks/useLanguageSwitcher';
export { localeConfig } from './config';
